import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/NavBar.css';

const NavBar = () => {
    const { user, logout } = useAuth();
    
    // Estado para el menú principal (hamburguesa)
    const [menuAbierto, setMenuAbierto] = useState(false);
    
    // Estado para controlar qué submenú está desplegado en móvil
    const [submenuActivo, setSubmenuActivo] = useState(null);

    const toggleMenu = () => {
        setMenuAbierto(!menuAbierto);
        // Si cerramos el menú principal, reseteamos los submenús
        if (menuAbierto) setSubmenuActivo(null); 
    };

    const closeMenu = () => {
        setMenuAbierto(false);
        setSubmenuActivo(null);
    };

    // --- LÓGICA HÍBRIDA (CLIC en Móvil / HOVER en Escritorio) ---
    const handleDropdownClick = (e, nombreSubmenu) => {
        // Detectamos si es pantalla móvil (menor a 768px)
        if (window.innerWidth < 768) {
            e.preventDefault(); // ¡STOP! No navegues a la página
            e.stopPropagation(); // Evita conflictos de clic
            
            // Si ya estaba abierto, lo cerramos (null). Si no, lo abrimos.
            setSubmenuActivo(submenuActivo === nombreSubmenu ? null : nombreSubmenu);
        }
        // En escritorio no hacemos nada: el CSS se encarga del hover y el Link funciona normal
    };

    return (
        <nav className="header">
            {/* BOTÓN HAMBURGUESA */}
            {/* El estilo 'open' rota el ícono si quieres agregar CSS para eso */}
            <div 
                className={`header__open-nav-button ${menuAbierto ? 'open' : ''}`} 
                onClick={toggleMenu}
                role="button"
            >
                {menuAbierto ? '✕' : '☰'} 
            </div>

            {/* LOGO */}
            <Link to="/" className="header__logo-container" onClick={closeMenu}>
                <img className="header__logo" src="/resources/escudoProgreso.png" alt="Logo" />
            </Link>

            {/* CONTENEDOR DEL MENÚ */}
            <div className={`header__nav ${menuAbierto ? 'open' : ''}`}>
                <ul className="header__nav-list">
                    <li className="header__nav-item">
                        <Link to="/" onClick={closeMenu}>INICIO</Link>
                    </li>
                    
                    {/* DROPDOWN PUEBLO */}
                    <li className={`header__nav-item dropdown-container ${submenuActivo === 'pueblo' ? 'active' : ''}`}>
                        {/* El onClick maneja la apertura en móvil */}
                        <Link to="/Informacion" onClick={(e) => handleDropdownClick(e, 'pueblo')}>
                            PUEBLO 
                            {/* Flechita visual opcional */}
                            
                        </Link>
                        
                        <ul className="dropdown">
                            <li className="dropdown-item"><Link to="/Informacion#elPueblo" onClick={closeMenu}>El pueblo</Link></li>
                            <li className="dropdown-item"><Link to="/Informacion#espaciosPublicos" onClick={closeMenu}>Espacios públicos</Link></li>
                            <li className="dropdown-item"><Link to="/Informacion#datosUtiles" onClick={closeMenu}>Teléfonos útiles</Link></li>
                            <li className="dropdown-item"><Link to="/Informacion#plano" onClick={closeMenu}>Plano</Link></li>
                        </ul>
                    </li>

                    <li className="header__nav-item">
                        <Link to="/Gobierno" onClick={closeMenu}>GOBIERNO</Link>
                    </li>

                    {/* DROPDOWN TRAMITES */}
                    <li className={`header__nav-item dropdown-container ${submenuActivo === 'tramites' ? 'active' : ''}`}>
                        <Link to="/Tramites" onClick={(e) => handleDropdownClick(e, 'tramites')}>
                            TRAMITES
                            
                        </Link>
                        
                        <ul className="dropdown">
                            <li className="dropdown-item"><Link to="/Tramites#tramitesAdministrativos" onClick={closeMenu}>Trámites Administrativos</Link></li>
                            <li className="dropdown-item"><Link to="/Tramites#serviciosPublicos" onClick={closeMenu}>Recolección de residuos</Link></li>
                        </ul>
                    </li>

                    <li className="header__nav-item">
                        <Link to="/Noticias" onClick={closeMenu}>NOTICIAS</Link></li>

                    {user && (
                        <li className="header__nav-item">
                            <button onClick={() => { logout(); closeMenu(); }} className="header__auth-btn logout">
                                CERRAR SESIÓN
                            </button>
                        </li>
                    )}
                </ul>
            </div>
        </nav>
    );
};

export default NavBar;